module.exports = __webpack_public_path__ + "static/media/Telegram.10b71eb5.png";